export default {
  state: {
    nearByDrivers: {
      list: [],
      loading: false
    },
    driverInPopup: {
      id: null,
      phone: null,
      email: null,
      firstName: null,
      lastName: null,
      photoUrl: null,
      vehicle: {
        name: null,
        licensePlate: null,
        photoUrl: null
      }
    },
    driverInPopupRoute: {
      path: [],
      distance: null, // in miles
      duration: null // in minutes
    },
    qualifiedDriver: {
      list: [],
      details: {},
      refresh: false,
      active: false
    },
    driverAvailability: {
      lastCheckId: '',
      checkId: '',
      rsvpData: {}
    }
  },
  mutations: {
    setNearByDrivers (state, data) {
      for (let field in data) {
        state.nearByDrivers[field] = data[field]
      }
    },
    setDriverInPopup (state, value) {
      state.driverInPopup = value
    },
    setDriverInPopupRoute (state, value) {
      state.driverInPopupRoute = value
    },
    setQualifiedDriversData (state, data) {
      for (let field in data) {
        state.qualifiedDriver[field] = data[field]
      }
    },
    reduceQualifiedDrivers (state) {
      state.qualifiedDriver.list.shift()
    },
    setDriverAvailabilityData (state, data) {
      for (let field in data) {
        state.driverAvailability[field] = data[field]
      }
    },
  }
}


// WEBPACK FOOTER //
// ./src/store/runs/drivers.js